export const calculateLTV = (
  value: string | number,
  pricePerGram: number,
  conversion: 'GOLD-TO-AMOUNT' | 'AMOUNT-TO-GOLD'
): number => {
  const valueNum = typeof value === 'number' ? value : parseInt(value, 10);

  if (Number.isNaN(valueNum)) {
    return 0;
  }

  if (!pricePerGram) {
    return 0;
  }

  if (conversion === 'AMOUNT-TO-GOLD') {
    const result = (valueNum / pricePerGram).toFixed(2);
    return parseFloat(result);
  }

  if (conversion === 'GOLD-TO-AMOUNT') {
    const result = (valueNum * pricePerGram).toFixed(2);
    return parseFloat(result);
  }

  return 0;
};
